import { espnswflTheme } from './sites';

// Simplify imports for storybook
export const defaultTheme = espnswflTheme;
